import DmsSyncType from '@/shared/constants/DmsSyncType';
import DmsSyncStatus from '@/shared/models/DmsSyncStatus';

export default class DmsObjectStatus {
  dmsSyncType!: DmsSyncType;
  payload!: string | DmsSyncStatus;
}